import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import type { components } from "@/api/schema";
import { Badge } from "@/shared/ui/badge";

import { promotionStatusIntent } from "../lib/status";

type PromotionStatus = components["schemas"]["Promotion"]["status"];

/**
 * Status badge for a promotion row. Intent comes exclusively from
 * `promotionStatusIntent()` (F1) — never a raw `statusIntent()`, because the BE
 * carries `finish`/`archived` codes outside the shared taxonomy.
 */
export function PromotionStatusBadge({
  status,
  dot = true,
}: {
  status: PromotionStatus;
  /** Header passes `status === "active"` (spec §5.3: static dot on Active, none on Finished). */
  dot?: boolean;
}): JSX.Element {
  const { t } = useTranslation("promotion");
  return (
    <Badge
      dot={dot}
      intent={promotionStatusIntent(status)}
      data-testid="promotion-status-badge"
      data-status={status}
    >
      {t(`status.${status}`)}
    </Badge>
  );
}
